<template>
    <div>
        <label class="v-label theme--light">{{label}}</label>
        <v-list :key="renderKey">
            <draggable v-model="namelist" @change="$emit('input', namelist); $emit('change')" tag="ContentsContainer">
                <v-list-item v-for="(item,itemindex) in namelist" :key="item.id">
                    <v-row no-gutters>
                        <v-col cols=10>
                            <v-text-field v-model="item.name" @input="$emit('input', namelist)" @change="$emit('change')" />
                        </v-col>
                        <v-col cols=2>
                            <v-btn
                                @click="removeItem(namelist, itemindex)"
                                color="error"
                                fab
                                small
                                style="margin-top: 12px; margin-left: 8px"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </draggable>
        </v-list>

        <v-btn
            @click="addItem(namelist)"
            color="zoezi-edit-color"
            fab
            small
            class="mb-2"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>


<script>
import components from '../component.js';
import Draggable from 'vuedraggable';
export default {
    name: 'NameListSetting',

    components: {
        Draggable
    },

    props: ['value', 'label', 'prop', 'component'],
    data: () => ({
        renderKey: 0,
        namelist: null
    }),
    methods: {
        removeItem(item, itemindex) {
            item.splice(itemindex, 1);
            this.$emit('input', this.namelist);
            this.$emit('change');
            ++this.renderKey;
        },
        addItem(items) {
            let newitem = {};

            newitem.name = this.prop.typeinfo.getNewName(items);

            items.splice(items.length, 0, components.makeEmptyConfig(newitem));
            this.setSelectedEditComponent(items[items.length-1]);
            this.$emit('input', this.namelist);
            this.$emit('change');
            ++this.renderKey;
        },
        componentInfo(name) {
            return components.getComponent(name);
        },
        setSelectedEditComponent(config) {
            this.$store.dispatch('setEditComponentConfig', {config, parentComponent: this.component})
        }
    },
    created() {
        this.namelist = this.value;
    }
}
</script>
